import { drama } from '../../../constants/actionTypes';

const initState = 0;

export default (state = initState, { type, count }) => {
  switch (type) {
    case drama.FETCH_DRAMA_PINNED_COMMENTS_SUCCESS:
      return count;

    case drama.CLEAN_COMMENTS:
      return initState;

    default:
      return state;
  }
};
